<div class="message-renderer" *ngIf="doc?.blocks?.length">
  <ng-container *ngFor="let block of doc!.blocks">
    <ng-container *ngIf="!block.hidden" [ngSwitch]="block.type">

      <app-mr-icon-badge *ngSwitchCase="'iconBadge'" [block]="asIconBadge(block)" [lang]="effectiveLang"></app-mr-icon-badge>
      <app-mr-heading *ngSwitchCase="'heading'" [block]="asHeading(block)" [lang]="effectiveLang"></app-mr-heading>
      <app-mr-paragraph *ngSwitchCase="'paragraph'" [block]="asParagraph(block)" [lang]="effectiveLang"></app-mr-paragraph>
      <app-mr-card-group *ngSwitchCase="'cardGroup'" [block]="asCardGroup(block)" [lang]="effectiveLang"></app-mr-card-group>
      <app-mr-note *ngSwitchCase="'note'" [block]="asNote(block)" [lang]="effectiveLang"></app-mr-note>
      <app-mr-button *ngSwitchCase="'button'" [block]="asButton(block)" [lang]="effectiveLang" (action)="action.emit($event)"></app-mr-button>
      <app-mr-stepper *ngSwitchCase="'stepper'" [block]="asStepper(block)" [lang]="effectiveLang"></app-mr-stepper>
      <app-mr-list *ngSwitchCase="'list'" [block]="asList(block)" [lang]="effectiveLang"></app-mr-list>

    </ng-container>
  </ng-container>
</div>
